import React from "react";
import { Outlet, useLocation, useMatch } from "react-router-dom";
import Reporting from "./Reporting";
import { DataService } from "../services/supabase";
import { SavedAnalysis, Dashboard } from "../types/analytics";
import { Transaction } from "../types";

export interface ReportingLayoutProps {
  dataService: DataService | null;
  onDataUpdate?: () => void;
  onAnalysesUpdate: (analyses: SavedAnalysis[]) => void;
  onDashboardsUpdate: (dashboards: Dashboard[]) => void;
  savedAnalyses: SavedAnalysis[];
  dashboards: Dashboard[];
  transactions: Transaction[];
  gradingOrders: any[];
  expenses: any[];
}

/**
 * Wraps reporting routes: main hub at `/reporting`, full-page analysis editor under `/reporting/analysis/*`.
 */
const ReportingLayout = (props: ReportingLayoutProps) => {
  const location = useLocation();
  const isReportingIndex = useMatch({ path: "/reporting", end: true });

  if (isReportingIndex) {
    return <Reporting {...props} />;
  }

  if (location.pathname.startsWith("/reporting/analysis")) {
    return <Outlet context={props} />;
  }

  return <Reporting {...props} />;
};

export default ReportingLayout;
